import { render, staticRenderFns } from "./CallUpdateTeam.vue?vue&type=template&id=c61f981a"
import script from "./CallUpdateTeam.vue?vue&type=script&lang=js"
export * from "./CallUpdateTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports